const projects = [
  {
    title: "Streamline Orchestrator",
    description:
      "Enabled near real-time transit analytics across 42 Bronx taxi zones by architecting a Kubernetes pipeline with Kafka and Neo4j. Identified optimal transit routes across 1,500+ trip records using PageRank and Dijkstra's algorithms via Neo4j GDS.",
    image: "/Assets/Projects/StreamlineOrchestrator.png",
    link: "https://github.com/sriranjan06/Streamline-Orchestrator",
  },
  {
    title: "Serenity Homes",
    description:
      "Built and deployed a MERN-stack real estate marketplace with JWT and Google OAuth dual authentication and 13 REST endpoints. Implemented role-based CRUD, Firebase image uploads, and multi-filter search with pagination across 5 query dimensions.",
    image: "/Assets/Projects/SerenityHomes.jpg",
    link: "https://serenity-homes.onrender.com/",
  },
  {
    title: "Connectify",
    description:
      "Connectify is a full-stack social media app with a responsive Next.js and Tailwind CSS frontend, powered by a robust Spring Boot and MySQL backend. It features Google authentication, dynamic posts, and efficient state management with Redux Toolkit.",
    image: "/Assets/Projects/Connectify.jpg",
    link: "https://github.com/sriranjan06/Connectify-Social-Media-App",
  },
  {
    title: "Account Administration System",
    description:
      "A full stack web application with admin authentication implementation using Next.js, Spring Boot, MySQL, TailwindCSS, Headless UI, NextAuth.js, Spring Data JPA, Web and Test.",
    image: "/Assets/Projects/Account-Admin.jpg",
    link: "https://github.com/sriranjan06/Account-Administration-System",
  },
  {
    title: "Employee Management Service",
    description:
      "An employee management system built with React.js, Spring Boot, MySQL, and Tailwind CSS, simplifying employee record management with a user-friendly interface, robust backend, and reliable database support.",
    image: "/Assets/Projects/Employee-Management.jpg",
    link: "https://github.com/sriranjan06/Employee-Management-Service",
  },
  {
    title: "Malaria Diagnosis using Deep Learning",
    description:
      "This project uses machine learning models, including SVM, KNN, ANN, and CNN, to classify blood cell images as infected or uninfected with malaria, featuring detailed preprocessing and performance evaluation.",
    image: "/Assets/Projects/Malaria-Diagnosis.png",
    link: "https://github.com/sriranjan06/Diagnosis-of-Infectious-Diseases-using-Machine-Learning-Models",
  },
  {
    title: "Global Renewable Energy Trends",
    description:
      "This project examines global renewable energy trends, focusing on solar, wind, and hydroelectric sources. It explores growth patterns, regional disparities, and their impact on GDP, using visualizations to highlight challenges and opportunities in adoption.",
    image: "/Assets/Projects/GlobalEnergy.jpg",
    link: "https://github.com/sriranjan06/Global-Renewable-Energy-Trends",
  },
  {
    title: "Targeted Enrollment Analytics",
    description:
      "This project leverages U.S. Census data to identify demographic and socioeconomic factors influencing income levels, aiming to enhance university enrollment. Through data visualizations, it uncovers insights to develop targeted marketing profiles for individuals earning $50,000 or less annually.",
    image: "/Assets/Projects/TargetedEnrollment.jpg",
    link: "https://github.com/sriranjan06/Targeted-Enrollment-Analytics",
  },
];

export default projects;
